<template>
  <div class="flex sm12 xs12">
    <span id="p-add-up">
      <ProductsAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('products.cards.title')">
      <template slot="actions">
        <va-popover :message="`${$t('products.tooltips.order')}`" placement="bottom">
          <va-button
            color="gray"
            icon="fa fa-list-ul"
            :to="{ name: 'products-order'}"
          />
        </va-popover>
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#p-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="products"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="image" slot-scope="props">
          <div class="d-flex justify-content-center img-logo">
            <img :src="$store.getters['environment/cdn'] + '/products/' + props.rowData.image"/>
          </div>
        </template>
        <template
          slot="actions"
          slot-scope="props"
        >
          <va-popover :message="`${$t('products.tooltips.stock')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-truck"
              :to="{ name: 'stock', params: { id: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('products.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#p-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('products.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ProductsAddUpdate from './ProductsAddUpdate'
const perPage = 10
export default {
  name: 'Products',
  components: {
    ProductsAddUpdate,
  },
  data () {
    return {
      perPage: perPage,
      products: [],
      page: 1,
      showAdd: false,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
    }
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('products.headings.name'),
      }, {
        name: '__slot:image',
        title: this.$t('products.headings.image'),
        width: '6rem',
        dataClass: 'text-center',
        titleClass: 'text-center',
      }, {
        name: 'description',
        title: this.$t('products.headings.description'),
      }, {
        name: 'value',
        title: this.$t('products.headings.value'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }, {
        name: 'available',
        title: this.$t('products.headings.available'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }]
    },
  },
  apollo: {
    products: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int) {
        products: product(limit: $perPage, offset: $page, order_by: {order: asc}) {
          id
          name
          description
          value
          image
          available
        }
      }
      `,
      variables () {
        return {
          perPage: this.perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery {
        pages: product_aggregate  {
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.products.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.image,
            path: 'products',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_product_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style>
.img-logo img {
  width: 6rem;
}
</style>
